import { render, staticRenderFns } from "./RenewLoginForms.vue?vue&type=template&id=1049ce5a&"
import script from "./RenewLoginForms.vue?vue&type=script&lang=js&"
export * from "./RenewLoginForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports